// extracted by mini-css-extract-plugin
export default {"overlay":"Modal__overlay--kwcuA","window":"Modal__window--E6HUJ"};